// extracted by mini-css-extract-plugin
export default {"logo":"FinishVerification_logo__H-gLh","empty":"FinishVerification_empty__9dOMF","text":"FinishVerification_text__ZpFjd","button":"FinishVerification_button__rd51X"};